import { shape, number, string, bool } from 'prop-types';
import bankBasicInformationPropTypes from '../../bank/proptypes/BankPropTypes';

const bankAccountBasicInformationPropTypes = {
  id: number.isRequired,
  accountNumber: string.isRequired,
  interbankNumber: string.isRequired,
  currency: number.isRequired,
  bankId: number.isRequired,
  bank: shape(bankBasicInformationPropTypes).isRequired,
  businessId: shape({
    id: number.isRequired,
    name: string.isRequired,
  }).isRequired,
  active: bool.isRequired,
  sunatTableCode: string.isRequired,
  externalAccountId: string,
};

export default bankAccountBasicInformationPropTypes;
